<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import Router from '@/router/index.js'
import SearchableInput from '@/components/SearchableInput.vue'

const props = defineProps({
  returnPath: { type: String, required: false },
  customer: { type: Object, required: false },
  resetAfterSelection: { type: Boolean, required: false, default: true },
})

const emit = defineEmits(['selected'])
const query = ref(props.customer?.company ?? '')

watch(
  () => props.customer,
  (val) => {
    if (val?.company) {
      query.value = val.company
    }
  }
)

const selected = (val) => {
  const copy = JSON.parse(JSON.stringify(val))
  emit('selected', copy)

  if (props.resetAfterSelection) {
    query.value = ''
  } else {
    query.value = copy.company ?? ''
  }
}

const addCustomerWindow = (value) => {
  Router.push({
    name: 'customer-create',
    query: {
      customerName: value,
      returnPath: props.returnPath ?? null,
    },
  })
}
</script>
<template>
  <SearchableInput
    v-model="query"
    :url="`/api/customer/search?query=`"
    :placeholder="'Find or add a customer...'"
    :output="val => val.company"
    :canAdd="true"
    :clearOnSelect="false"
    :autoShowResults="false"
    @selected="selected"
    @empty="addCustomerWindow"
  />
</template>
